import { render, staticRenderFns } from "./StudentInformationStatus.vue?vue&type=template&id=79f1a810&scoped=true&lang=pug&"
import script from "./StudentInformationStatus.vue?vue&type=script&lang=ts&"
export * from "./StudentInformationStatus.vue?vue&type=script&lang=ts&"
import style0 from "./StudentInformationStatus.vue?vue&type=style&index=0&id=79f1a810&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f1a810",
  null
  
)

export default component.exports